import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Container } from "../../../components/Container";
import { ToggleSwitchBillingPaymentScheduleType } from "../../../components/ToggleSwitchBillingPaymentScheduleType";
import { updateBillingPaymentDate, updateBillingPaymentScheduleType } from "../../../reducers/billingReducer";
import {
  getBillingIsUpdating,
  getBillingPaymentSchedule,
  getBillingPaymentScheduleType,
  getIsBillingInNewStatus,
} from "../../../selectors/billing";
import { useAppDispatch } from "../../../store";
import { UpdateBillingPaymentScheduleDate } from "../../../types/billing";
import { BillingPaymentScheduleType } from "../../../types/billings";
import { BillingPaymentSchedulePicker } from "./BillingPaymentSchedulePicker";

import styles from "./BillingPaymentSchedule.module.scss";

export const BillingPaymentSchedule = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const paymentSchedule = useSelector(getBillingPaymentSchedule);
  const paymentScheduleType = useSelector(getBillingPaymentScheduleType);
  const isBillingInNewStatus = useSelector(getIsBillingInNewStatus);
  const isUpdating = useSelector(getBillingIsUpdating);

  const onBillingPaymentScheduleTypeChange = (value: string) => {
    dispatch(updateBillingPaymentScheduleType(value as BillingPaymentScheduleType));
  };

  const onBillingPaymentDateChange = (payload: UpdateBillingPaymentScheduleDate) => {
    dispatch(updateBillingPaymentDate(payload));
  };

  const isDisabled = isUpdating || !isBillingInNewStatus;

  return (
    <Container>
      <div className={styles.header}>
        <h3 className={styles.title}>{t("billingPaymentSchedule.title")}</h3>
        <ToggleSwitchBillingPaymentScheduleType
          selectedValue={paymentScheduleType}
          onChange={onBillingPaymentScheduleTypeChange}
          isDisabled={isDisabled}
        />
      </div>
      <BillingPaymentSchedulePicker
        isDisabled={isDisabled}
        paymentSchedule={paymentSchedule}
        paymentScheduleType={paymentScheduleType}
        onPaymentDateChange={onBillingPaymentDateChange}
      />
    </Container>
  );
};
